export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID;

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: string) => {
  try {
    (window as any).gtag("config", GA_TRACKING_ID, {
      page_path: url,
    });
  } catch {}
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }: any) => {
  try {
    (window as any).gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  } catch {}
};
